export const LISTITEMS: any[] = [
    { 'url': '/page', 'name': 'Page', 'icon': 'ft-home' },
    { 'url': '/auth/login', 'name': 'Login', 'icon': 'ft-log-in' },
];

